// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__RipfG","modalFooterButton":"ModalNotes_modalFooterButton__2gQnE"};